
import $ from 'jquery'; // from node_modules
window.jQuery = $;

$(document).ready(function () {
    var swiper = new Swiper(".swiperLoghi", {
        slidesPerView: 8,
        spaceBetween: 15,
        loop: true,
        freeMode: true,
        freeModeMomentum: false, // importante: niente rallentamenti
        allowTouchMove: false,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 6,
            },
            1300: {
                slidesPerView: 8,
            },
        },
    });
});

if($('.row-truck').length > 0) {
    $('.show-detail').each(function() {
        $(this).on('click', function(e) {
            e.preventDefault();
            var parentRow = $(this).parents('.row-truck');
            var singleTruck = $(this).parents('.truck-servizio');
            var title = singleTruck.data('title');
            var lunghezza = singleTruck.data('lunghezza');
            var altezza = singleTruck.data('altezza');
            var capacita = singleTruck.data('capacita');
            var imgFront = singleTruck.data('front');
            var imgBack = singleTruck.data('back');
            var imgExtra = singleTruck.data('extra');
            $('.detail-truck-desktop').removeClass('show');
            $('.detail-mobile-truck').removeClass('show');
            $('.title-detail-truck').html('');
            $('.lunghezza-detail-truck').html('');
            $('.altezza-detail-truck').html('');
            $('.capacita-detail-truck').html('');
            $('.front-detail-truck').attr('src', '');
            $('.back-detail-truck').attr('src', '');
            if(!imgExtra){
                $('.extra-camion').hide();
            }else{
                $('.extra-camion').show();
            }
            $('.extra-detail-truck').attr('src', '');
            if($(window).width() > 650) {
                parentRow.next('.detail-truck-desktop').addClass('show');
                parentRow.next('.detail-truck-desktop').find('.title-detail-truck').html(title);
                parentRow.next('.detail-truck-desktop').find('.lunghezza-detail-truck').html(lunghezza);
                parentRow.next('.detail-truck-desktop').find('.altezza-detail-truck').html(altezza);
                parentRow.next('.detail-truck-desktop').find('.capacita-detail-truck').html(capacita);
                parentRow.next('.detail-truck-desktop').find('.front-detail-truck').attr('src', imgFront);
                parentRow.next('.detail-truck-desktop').find('.back-detail-truck').attr('src', imgBack);
                parentRow.next('.detail-truck-desktop').find('.extra-detail-truck').attr('src', imgExtra);
                setTimeout(function(){
                    $("html, body").animate({ scrollTop: parentRow.next('.detail-truck-desktop.show').offset().top }, 600, 'swing');
                },300)
            }else{
                singleTruck.next('.detail-mobile-truck').addClass('show');
                singleTruck.next('.detail-mobile-truck').find('.title-detail-truck').html(title);
                singleTruck.next('.detail-mobile-truck').find('.lunghezza-detail-truck').html(lunghezza);
                singleTruck.next('.detail-mobile-truck').find('.altezza-detail-truck').html(altezza);
                singleTruck.next('.detail-mobile-truck').find('.capacita-detail-truck').html(capacita);
                singleTruck.next('.detail-mobile-truck').find('.front-detail-truck').attr('src', imgFront);
                singleTruck.next('.detail-mobile-truck').find('.back-detail-truck').attr('src', imgBack);
                singleTruck.next('.detail-mobile-truck').find('.extra-detail-truck').attr('src', imgExtra);
                setTimeout(function(){
                    $("html, body").animate({ scrollTop: singleTruck.next('.detail-mobile-truck.show').offset().top }, 600, 'swing');
                },300);
            }
        });
    });
    $('.close-detail').click(function(e){
        e.preventDefault();
        $('.detail-truck-desktop').removeClass('show');
        $('.detail-mobile-truck').removeClass('show');
        $('.title-detail-truck').html('');
        $('.lunghezza-detail-truck').html('');
        $('.altezza-detail-truck').html('');
        $('.capacita-detail-truck').html('');
        $('.front-detail-truck').attr('src', '');
        $('.back-detail-truck').attr('src', '');
    });
}
